import cx from 'classnames';
import { EditableInput } from '@common/components/EditableInput';
import { Flex } from '@common/components/Flex';
import ActionsButton from '@common/components/ActionsButton';
import { getTestAttributes } from '@common/utils/tests';

import './tree-item.styles.scss';

export class TreeItem extends React.PureComponent {
  static defaultProps = {
    normalizeId: Number,
    itemSelectedImgSrc: 'gif/folder_open.gif',
    itemNotSelectedImgSrc: 'gif/folder_closed.gif',
    features: {},
  };

  getActionsBtnId = () => {
    const { getId, parentIndex, ownIndex, data } = this.props;

    if (this.props.getId?.actionBtn) {
      return this.props.getId?.actionBtn({ parentIndex, ownIndex, data });
    }
  }

  render() {
    const { 
      getId,
      data, 
      features, 
      getActions,
      isChild, 
      isCollapsed, 
      isRenamingName, 
      getState, 
      itemNotSelectedImgSrc,
      itemSelectedImgSrc, 
      onActionsOpen,
      onChange, 
      onCollapsedChange,
      onCreateItemSubmit,
      onItemNameSubmit,
      parentIdOfCreatingItemId,
      renamingItem,
      shouldDisableItem, 
      renderChild,
      parentIndex,
      ownIndex,
    } = this.props;
    const children = data.children || [];
    const disabled = shouldDisableItem(data);
    const collapsed = isCollapsed(data.id);
    const { selected, indeterminate } = getState(data.id);
    const actions = getActions(data);
    const renamingName = isRenamingName(data.id);
    const withCollapse = features.collapsing && Boolean(children?.length);

    return (
      <div
        className={cx(
          "Tree__item",
          { "Tree__item-child": isChild },
          { "Tree__item-parent": !isChild }
        )}
      >
        <div
          role="button"
          title={data.name}
          className={cx(
            "Tree__item__label",
            { "Tree__item__label-disabled": disabled },
            { "Tree__item__label-selected": selected },
            { "Tree__item__label-with-toggle-icon": withCollapse },
          )}
          tabIndex="0"
          aria-pressed="false"
          data-id={data.id}
          {...getTestAttributes({ id: getId?.folder ? getId.folder({ parentIndex, ownIndex, data }) : "tree-folder-item" + data.id })}
          onClick={renamingName ? undefined : onChange}
          onContextMenu={renamingName ? undefined : onChange}
        >
          {!renamingName && (
            <React.Fragment>
              <Flex wrap="nowrap" alignItems="center" width="calc(100% - 24px)">
                {withCollapse && (
                  <span
                    className={cx(
                      "Tree__item__toggle-icon",
                      "fa",
                      { "fa-angle-down": !collapsed },
                      { "fa-angle-right": collapsed }
                    )}
                    {...getTestAttributes({ id: getId?.collapseIcon ? getId.collapseIcon({ parentIndex, ownIndex, data }) : "tree-folder-item-collapse-icon_" + data.id })}
                    data-id={data.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      onCollapsedChange(e);
                    }}
                  />
                )}
                {features.checkbox && (
                  <input
                    className={cx('Tree__item__checkbox', { 'Tree__item__checkbox--indeterminate': indeterminate })}
                    type="checkbox"
                    readOnly
                    {...getTestAttributes({ id: getId?.renameInput ? getId?.renameInput({ parentIndex, ownIndex, data }) : 'tree-folder-item-rename-input_' + data.id })}
                    checked={selected}
                  />
                )}
                {features.folderImg && (
                  <img
                    {...getTestAttributes({ id: getId?.icon ? getId?.icon({ parentIndex, ownIndex, data }) : 'tree-folder-item-icon_' + data.id })}
                    className="Tree__item__img"
                    src={
                      (!collapsed || selected)
                        ? data.imageURLSelected || itemSelectedImgSrc
                        : data.imageURL || itemNotSelectedImgSrc
                    }
                  />
                )}
                <div className="Tree__item__label__text">{data.name}</div>
              </Flex>
              {Boolean(actions.length) && (
                <ActionsButton
                  withStopPropagation={false}
                  variant="arrow-down"
                  id={data.id}
                  getId={{
                    triggerBtn: getId?.actionBtn ? this.getActionsBtnId : undefined
                  }}
                  data={data}
                  menuItems={actions}
                  classes={{ triggerBtn: "Tree__item__actions-btn" }}
                  onOpen={onActionsOpen}
                />
              )}
            </React.Fragment>
          )}
          {renamingName && (
            <React.Fragment>
              <img
                className="Tree__item__img"
                src={
                  (!collapsed || selected)
                      ? data.imageURLSelected || itemSelectedImgSrc
                      : data.imageURL || itemNotSelectedImgSrc
                }
              />
              <EditableInput
                native
                defaultValue={renamingItem.name}
                classes={{
                  root: cx("Tree__item__name-manager"),
                  input: "Tree__item__name-manager__input",
                }}
                onSave={onItemNameSubmit}
              />
            </React.Fragment>
          )}
        </div>
        {data.id == parentIdOfCreatingItemId && (
          <Flex
            className="Tree__item__creating"
            wrap="nowrap"
            alignItems="center"
          >
            <img
              className="Tree__item__img"
              src={
                (!collapsed || selected)
                  ? data.imageURLSelected || itemSelectedImgSrc
                  : data.imageURL || itemNotSelectedImgSrc
              }
            />
            <EditableInput
              native
              classes={{
                root: cx("Tree__item__name-manager"),
                input: "Tree__item__name-manager__input",
              }}
              onSave={onCreateItemSubmit}
            />
          </Flex>
        )}
        {!collapsed &&
          children.map((child, i) => (
            <React.Fragment key={child.id} >
              {renderChild(child, { ownIndex: i, parentIndex: ownIndex })}
            </React.Fragment>
          ))}
      </div>
    );
  }
}
